export const DEFAULT_SERVER_TIME = -1;
export const ELECTION_API_URL = "https://canopy.cbc.ca/live/elections/prov";
